<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>
    <el-row class="filter">
      <el-col :span="12" style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>改标类型列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="showGbDiaLog"
            >添加</el-button
          >
          <el-button type="primary" size="mini" @click="output">导出</el-button>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            :data="resData.list"
            tooltip-effect="dark"
          >
            <el-table-column
              prop="id"
              label="序号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="改标类型"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="code"
              label="改标类型编码"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="piece_coefficient"
              label="计件系数"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="admin_name"
              label="更新人"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="update_time"
              label="更新时间"
              width="160px"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="editGbType(scope.row)">
                  编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="diaLogTitle"
      :visible.sync="gbTypeFormVisible"
      width="30%"
      :before-close="handleGbTypeClose"
      center
    >
      <el-form :model="form" label-width="110px">
        <el-form-item label="改标类型编码" required>
          <el-input
            v-model="form.code"
            size="mini"
            :readonly="readonly"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
        <el-form-item label="改标类型名称" required>
          <el-input v-model="form.name" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="计件系数" required>
          <el-input v-model="form.piece_coefficient" size="mini"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleGbTypeClose">取 消</el-button>
        <el-button size="mini" type="primary" @click="saveGbType">
          确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HeaderTabs from "../wavepicking/components/HeaderTabs";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  name: "GbTypeSetting",
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      loading: false,
      resData: {},
      diaLogTitle: "新建改标类型",
      gbTypeFormVisible: false,
      form: {
        id: null,
        name: "",
        code: "",
        piece_coefficient: "",
      },
      readonly: false,
      disabled: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post("/erp/GaiBiao/getGbTypeList", {}).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    saveGbType() {
      this.$http
        .post("/erp/GaiBiao/saveGbType", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.gbTypeFormVisible = false;
            this.fetchData(true);
            this.$message.success("操作成功");
          }
        });
    },
    showGbDiaLog() {
      this.gbTypeFormVisible = true;
      this.readonly = false;
      this.disabled = false;
      this.diaLogTitle = "新建改标类型";
    },
    editGbType(row) {
      this.gbTypeFormVisible = true;
      this.readonly = true;
      this.disabled = true;
      this.diaLogTitle = "编辑改标类型";
      this.form = {
        id: row.id,
        code: row.code,
        name: row.name,
        piece_coefficient: row.piece_coefficient,
      };
    },
    handleGbTypeClose() {
      this.form = {
        id: null,
        code: "",
        name: "",
        piece_coefficient: "",
      };
      this.gbTypeFormVisible = false;
      this.readonly = false;
      this.disabled = false;
    },
    output() {
      this.$http
        .post("/erp/GaiBiao/getGbTypeList", {
          task: 1,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/GaiBiao/GbTypeSetting.vue